import React, { useEffect, useState } from "react";
import { pad } from "../utils";
import { Note } from "./icons/Note";
import { AudioItem } from "./AudioItem";
import "../assets/styles/colors.css";

export const AlarmRinging = ({
  alarm: theAlarm,
  dismiss,
  soundPlaying,
  soundToPlay,
  setSoundToPlay,
  setSoundPlaying,
}) => {
  const [visible, setVisible] = useState(!!theAlarm);
  const [alarm, setAlarm] = useState(theAlarm);

  const onDismiss = () => {
    setSoundPlaying(() => false);
    setSoundToPlay(() => "");
    dismiss(null);
  };

  useEffect(() => {
    theAlarm && setAlarm(() => theAlarm);
    setVisible(() => theAlarm && soundPlaying && soundPlaying);
  }, [theAlarm, setSoundPlaying, soundPlaying, soundToPlay]);

  return (
    visible && (
      <div className="alarm-ringing-container">
        <AudioItem audio={soundToPlay} shouldPlay={soundPlaying} />
        <div className={`alarm-ringing alarm ${alarm?.color}`}>
          <div>
            <p className="alarm-label">{alarm?.label || "Alarm"}</p>
            <p className="alarm-time">
              {pad(alarm?.hours)} : {pad(alarm?.minutes)}
            </p>
            <div className="alarm-sound-container">
              <Note fill="var(--light)" size={15} />
              <p className="capitalize alarm-sound">{alarm?.sound}</p>
            </div>
          </div>
          <div>
            <button
              className="btn btn-light"
              onClick={() => onDismiss(alarm.id)}
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    )
  );
};
